import React from 'react';
import { GenericPageLayout } from '@layout/GenericPageLayout';
import { ERROR_CODES } from '@model/common/error-codes';
import { Error500 } from '@components/common/hero/error/Error500';
import { DestinationMeta } from '@components/content/destination/Head/DestinationMeta';
import { Logging } from '@util/logging';
import { DestinationPageToursLayoutProps } from './props';

/* ***************** *
 *       Layout       *
 * ***************** */
export const DestinationPageMultiCentreLayout = ({
  path,
  pageConfig,
  componentsData,
  destination,
  tripType,
  promoBannerTripType
}: DestinationPageToursLayoutProps) => {
  if (!pageConfig) {
    Logging.warn({ text: `No pageConfig for ${path} ${tripType}` });
    return <Error500 code={ERROR_CODES.NO_CMS_CONFIG} />;
  }
  if (!destination) {
    Logging.warn({ text: `No destination for ${path} ${tripType}` });
    return <Error500 code={ERROR_CODES.NO_API_DESTINATION} />;
  }

  const { components } = pageConfig;

  return (
    <>
      <GenericPageLayout
        components={components}
        componentsData={componentsData}
        tripType={tripType}
        path={path}
        destination={destination}
        promoBannerTripType={promoBannerTripType}
      />
      <DestinationMeta components={components} destination={destination} tripType={tripType} />
    </>
  );
};
